module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/1.png?6f24fce6";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/1.png
// module id = 2424
// module chunks = 0